import assets from './asset.js';
import shows from './shows.js';
import streaming from './streaming.js';
import '@dtvgo/typed-normalizr';
import '../../utils/normalizr/constants.js';
import '../../utils/normalizr/entities.js';
import 'query-string';
import '@dtvgo/constants';
import '../../utils/normalizr/interfaces.js';
import '../../utils/normalizr/utils.js';
import 'lodash/set';
import 'lodash/sortBy';
import 'lodash/mapKeys';
import 'lodash/defaultsDeep';

function v1(backendAxiosInstance) {
  return {
    ...assets(backendAxiosInstance),
    ...shows(backendAxiosInstance),
    ...streaming(backendAxiosInstance)
  };
}

export { v1 as default };
//# sourceMappingURL=index.js.map
